import { render, staticRenderFns } from "./OpenSubQuestion.vue?vue&type=template&id=406124f0&scoped=true"
import script from "./OpenSubQuestion.vue?vue&type=script&lang=js"
export * from "./OpenSubQuestion.vue?vue&type=script&lang=js"
import style0 from "./OpenSubQuestion.vue?vue&type=style&index=0&id=406124f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406124f0",
  null
  
)

export default component.exports